import { ApplicationState } from 'AppReducer'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { inputMaskMoney } from 'util/masks'
import { createBalance } from '../redux/actions'

const initialState = {
  type: 'PERSONAL', description: '', reference: '', amount: 0, amountFormated: 'R$ 0,00', multiplyFactor: 1
}
const NewBalance: React.FC<{ onCreate: () => void }> = ({ onCreate }) => {
  const dispatch = useDispatch()
  const { id } = useParams<{ id?: string }>()

  const [form, setForm] = useState(initialState)
  const [isFetching, setFeching] = useState(false)

  const { types } = useSelector((state: ApplicationState) => state.balanceReducer)

  async function handleSubmit (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    setFeching(true)
    if (id && form.amount > 0) {
      createBalance(id, { ...form, amount: form.amount * form.multiplyFactor })(dispatch).then(res => {
        if (res?.status === 'success') {
          onCreate()
        }
      })
    } else {
      alert('Valor de entrada precisa ser maior que zero')
    }
    setFeching(false)
  }

  const gridTemplateColumns = '125px 190px 1fr 200px 125px 150px'

  return (
    <div className="row panel margin-top-32">
      <div className="row justify-start">
        <h2><i className="fa fa-history"/> Nova Entrada</h2>
      </div>

      <form onSubmit={handleSubmit} className="row align-end" style={{ display: 'grid', gridTemplateColumns }}>
        <div className="form-control">
          <label>Forma</label>
          <select
            required
            value={form.multiplyFactor}
            onChange={(e): void => setForm({ ...form, multiplyFactor: parseInt(e.target.value) })}
          >
            <option value={1}>Entrada</option>
            <option value={-1}>Saida</option>
          </select>
        </div>
        <div className="form-control">
          <label>Tipo</label>
          <select
            required
            value={form.type}
            onChange={(e): void => setForm({ ...form, type: e.target.value })}
          >
            {
              Object
                .keys(types)
                .filter(key => key !== 'MONEY')
                .filter(key => key !== 'IN_APP')
                .filter(key => key !== 'CARD_MACHINE')
                .map((key) => <option value={key} key={key}>{ types[key] }</option>)
            }
          </select>
        </div>

        <div className="form-control">
          <label>Descrição</label>
          <input
            required
            type="text"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </div>

        <div className="form-control">
          <label>Referência</label>
          <input
            type="text"
            value={form.reference}
            placeholder="Ex: Cod Pedido"
            onChange={(e) => setForm({ ...form, reference: e.target.value })}
          />
        </div>

        <div className="form-control">
          <label>Valor</label>
          <input
            required
            type="text"
            value={form.amountFormated}
            placeholder="Ex: Cod Pedido"
            onChange={(e) => {
              const [amountFormated, amount] = inputMaskMoney(e.target.value, 'R$', { thousand: '.', hundred: '.' })
              setForm({ ...form, amount, amountFormated })
            }}
          />
        </div>

        <button className="button primary" disabled={isFetching}>
          {
            isFetching
              ? <span><i className="fas fa-spinner fa-spin"/> Carregando.</span>
              : <span><i className="fas fa-plus"/> Adicionar</span>
          }
        </button>
      </form>
    </div>
  )
}

export default NewBalance
